import React, { useEffect } from 'react'
import { Link, navigate, useIntl } from 'gatsby-plugin-intl'
import Layout from '../../components/Layout/index'
import Header from '../../modules/Header'
import Footer from '../../modules/Footer'
import SEO from '../../components/seo'
import PressRelease from '../../components/PressRelease'

import messages from '../../messages/pageTitles.lang'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import Image from '../../images/news/press-release-radevormwald.jpg'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  useEffect(() => {
    if (global.window && locale === 'en') {
      navigate('/newsroom/')
    }
  }, [])

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsRadevormwald)}
        imageAlt={formatMessage(messages.TitleNewsRadevormwald)}
        description={formatMessage(metaDescription.NewsRadevormwaldDescription)}
        nofollow={locale === 'en'}
        image={Image}
        lang={locale}
      />
      <PressRelease
        article={newsList.radevormwald}
        articleLinks={{
          dev: <Link to="/services/it-consulting/">https://www.freshcells.de/de/services/it-consulting</Link>
        }}
      />
    </Layout>
  )
}

export default IndexPage
